/* House of Khilonay - product card discount badges.
   Horizon renders a static "Sale" badge. This rewrites it to the real
   percentage off, computed from each card's own prices.
   Position and colour live in hok-badge.css. */
(function () {
  var DONE = 'hokBadge';
  var writing = false;

  /* Parse a money string into a number.
     Careful: "Rs.6,499.00" must not keep the dot from "Rs." - stripping
     everything except digits/dots/commas yields ".6499.00", which
     parseFloat reads as 0.6499. Drop separators first, then take the
     first digit run. */
  function toNumber(text) {
    if (!text) return NaN;
    var match = String(text).replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    if (!match) return NaN;
    var n = parseFloat(match[0]);
    return isNaN(n) ? NaN : n;
  }

  function pickPrice(scope, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var els = scope.querySelectorAll(selectors[i]);
      for (var j = 0; j < els.length; j++) {
        var n = toNumber(els[j].textContent);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    return NaN;
  }

  function label(card) {
    var badge = card.querySelector('.product-badges__badge');
    if (!badge) return true;
    if (badge.dataset[DONE]) return true;

    var current = (badge.textContent || '').trim().toLowerCase();

    if (current.indexOf('sold') !== -1) {
      badge.dataset[DONE] = 'skip';
      return true;
    }

    var sale = pickPrice(card, [
      '.price__sale .price-item--sale',
      '.price-item--sale',
      '.price__current'
    ]);
    var compare = pickPrice(card, [
      '.compare-at-price',
      '.price-item--regular'
    ]);

    if (isNaN(sale) || isNaN(compare) || compare <= sale) return false;

    var pct = Math.round(((compare - sale) / compare) * 100);
    if (pct < 1 || pct > 99) {
      badge.dataset[DONE] = 'skip';
      return true;
    }

    badge.textContent = pct + '% OFF';
    badge.classList.add('hok-badge-pct');
    badge.dataset[DONE] = '1';
    return true;
  }

  function run() {
    writing = true;
    var cards = document.querySelectorAll('product-card, .product-card');
    var outstanding = 0;
    for (var i = 0; i < cards.length; i++) {
      try {
        if (!label(cards[i])) outstanding++;
      } catch (e) {
        /* never break the page over a badge */
      }
    }
    setTimeout(function () {
      writing = false;
    }, 0);
    return outstanding;
  }

  var timer = null;

  function sweep() {
    clearInterval(timer);
    var elapsed = 0;
    run();
    timer = setInterval(function () {
      elapsed += 400;
      if (run() === 0 || elapsed >= 8000) clearInterval(timer);
    }, 400);
  }

  function start() {
    sweep();

    var pending = null;
    new MutationObserver(function () {
      if (writing) return;
      clearTimeout(pending);
      pending = setTimeout(sweep, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
